import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';

var TariffBillingListPage = function (_super) {
  __extends(TariffBillingListPage, _super);

  function TariffBillingListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.total = 0;
    _this.columns = [];
    _this.loadingStatus = false;
    _this.accountList = [];
    _this.selectedList = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    return _this;
  }

  TariffBillingListPage.prototype.getInitSearchData = function () {
    return {
      bill_number: '',
      account_code: undefined,
      timeArr: this.$util.getDefaultTimeCondition(),
      page_index: 1,
      page_size: 10
    };
  };

  TariffBillingListPage.prototype.created = function () {
    this.columns = [{
      title: this.t('账单号'),
      dataIndex: 'bill_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('主体信息'),
      scopedSlots: {
        customRender: 'mainBody'
      }
    }, {
      title: this.t('账单总金额'),
      align: 'right',
      scopedSlots: {
        customRender: 'allTotal'
      }
    }, {
      title: this.t('期初余额'),
      align: 'right',
      scopedSlots: {
        customRender: 'startBalance'
      }
    }, {
      title: this.t('期末余额'),
      align: 'right',
      scopedSlots: {
        customRender: 'endBalance'
      }
    }, {
      title: this.t('账单周期'),
      dataIndex: 'bill_period',
      filterEmpty: true
    }, {
      title: this.t('账单出具时间'),
      dataIndex: 'bill_examine_time',
      name: "bill_examine_time",
      filterEmpty: true
    }, {
      title: this.t('操作'),
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.queryTariffBillingList();
    this.queryAccountList();
  };

  TariffBillingListPage.prototype.queryTariffBillingList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _i, _a, key, data, _b, list, _c, total;

      var _this = this;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            postData = {};

            for (_i = 0, _a = Object.keys(this.searchData); _i < _a.length; _i++) {
              key = _a[_i];

              if (!this.searchData[key] && this.searchData[key] !== 0) {
                continue;
              }

              if (key === 'timeArr' && this.searchData[key].length) {
                postData.begin_time = this.$util.formatDateTime(this.searchData[key][0]);
                postData.end_time = this.$util.formatDateTime(this.searchData[key][1]);
                continue;
              }

              postData[key] = this.searchData[key];
            }

            this.lastParams = this.$util.deepCopy(postData);
            return [4, this.$api.finance.queryTariffBillList(postData)];

          case 1:
            data = _d.sent().data;
            _b = data.list, list = _b === void 0 ? [] : _b, _c = data.total, total = _c === void 0 ? 0 : _c;
            this.dataList = list.map(function (item) {
              return __assign(__assign({}, item), {
                bill_period: item.bill_from_time + _this.t('至') + item.bill_to_time
              });
            });
            this.total = total;
            return [2];
        }
      });
    });
  };

  TariffBillingListPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList = [];
    this.queryTariffBillingList();
  };

  TariffBillingListPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryTariffBillingList();
  };

  TariffBillingListPage.prototype.initPage = function () {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  };

  TariffBillingListPage.prototype.handleReset = function () {
    this.searchData = this.getInitSearchData();
    this.queryTariffBillingList();
  };

  TariffBillingListPage.prototype.queryAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryAccountList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.accountList = data.map(function (item) {
              return __assign({}, item);
            });
            return [2];
        }
      });
    });
  };

  TariffBillingListPage.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = selectedRowKeys;
  };

  TariffBillingListPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message, a, href;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData.bill_number_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData.bill_number_list = this.selectedList;
            }

            return [4, this.$api.finance.queryTariffBillExport(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              a = document.createElement('a');
              href = data;
              a.setAttribute('href', href);
              a.click();
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  __decorate([userPrefPageSize('tariffBillingList')], TariffBillingListPage.prototype, "getInitSearchData", null);

  __decorate([loading('loadingStatus')], TariffBillingListPage.prototype, "queryTariffBillingList", null);

  TariffBillingListPage = __decorate([Component], TariffBillingListPage);
  return TariffBillingListPage;
}(Vue);

export default TariffBillingListPage;